module.exports = __webpack_public_path__ + "img/制御工学1_8.c2ab2631.png";